module.exports = __webpack_public_path__ + "static/media/2018-02-18---Stargasm-logo2_02.436276ea.png";